// 环境配置文件
let env = "localhost"; //环境名称变量
const config = {
    localhost: {
        domain: 'localhost:8080',
        server: '/local'
    },
    dev: {
        domain: "192.168.93.13:8096", //本地环境，服务器地址需要在host配置
        server: "http://192.168.93.13:8087/yy-crm",
    },
    test: { // 测试环境
        domain: "192.168.93.14:8096", // 域名
        server: "http://192.168.93.14:8087/yy-crm", // 服务器地址
    },
    pre: { //预发布环境
        domain: "xc.pre.xxx.net", // 域名
        server: "http://xc.pre.xxx.net", // 服务器地址
    },
    prod: { //生产环境
        domain: "crm.delaman168.com",
        server: "http://8.129.24.175:8080/yy-crm",
    }
};
//根据域名判断环境
let hostname = location.host;
for (let i in config) {
    if (config[i].domain === hostname) {
        env = i;
        break;
    }
}
export default {
    cokieDomain: config[env].domain,
    env: env,
    serverPath: {
        server: config[env].server,
        workbenchUrl: config[env].workbenchUrl,
    }

};